import { createStore } from '@stencil/store';
import { ReelsModalState } from 'types';
import { orderVideos } from 'utils/reels';
import { changeOverflowBody } from 'utils/ui';
import initParams from './initParams';

const { state, onChange, on, set, reset } = createStore<ReelsModalState>({
  isOpen: false,
  startIndex: -1,
  index: -1,
  videos: [],
});

onChange('isOpen', newValue => {
  changeOverflowBody(newValue, initParams.isApp);
});

onChange('startIndex', newValue => {
  state.videos = orderVideos(state.videos, newValue);

  setTimeout(() => {
    state.index = 0;
  }, 500);
});

onChange('index', newValue => {
  const videoPlayerElement = document.getElementById(`video-player-${newValue}`) as HTMLVideoElement | null,
    videoPlayerModal = document.getElementById('video-player-modal');

  if (videoPlayerElement !== null && videoPlayerModal !== null) {
    videoPlayerModal.querySelectorAll('video').forEach(video => {
      video.pause();
    });

    const offSetTop = document.getElementById(`video-player-${newValue}`)?.offsetTop;
    if (!!offSetTop) {
      videoPlayerModal.scrollTop = offSetTop;
      videoPlayerElement.play();
    }
  }
});

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
